import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class ReportUserMail extends React.Component {

    static propTypes = {
        content: PropTypes.shape({
            userName: PropTypes.string.isRequired,
            reporterName: PropTypes.string.isRequired,
            reportType: PropTypes.string.isRequired
        })
    };

    render() {
        const { content: { userName, reporterName, reportType, logo, siteName } } = this.props;

        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
                <div style={body}>
                    <div style={fontWeightBold}>
                        Hi Admin,
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        A new user violation has been reported. Please review the details below:
                    </div>
                    <EmptySpace height={20} />
                    <div style={marginBottom}><span style={fontWeightBold}>Violation Details:-</span></div>
                    <div style={marginBottom}><span style={fontWeightBold}>Reported User:</span> {userName}</div>
                    <div style={marginBottom}><span style={fontWeightBold}>Violation Description:</span> {reportType}</div>
                    <div><span style={fontWeightBold}>Reported By:</span> {reporterName}</div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </div>
                <EmptySpace height={40} />
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default ReportUserMail;